// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".markdown-body[data-v-0f59e655] p:last-child{margin-bottom:0}.discussion__item[data-v-0f59e655]{max-height:100000px;transition:.5s ease-out}.discussion__item.--hidden[data-v-0f59e655]{max-height:0}.discussion__item .discussion__item-btn[data-v-0f59e655]{padding:0;width:20px;font-size:13px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
